import React from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

export const CurvedBackground: React.FC<sharedComponents.CurvedBackground> = ({ children, className = '' }) => (
  <div className={classNames(styles.backgroundContainer, { [className]: className })}>
    <div className={styles.curvedBackground} />
    {children}
  </div>
);
